const info = {

    ZH: {  //中文翻译
        choose: "请选择",
        packages: "包裹绑定订单",
        orders: "订单绑定包裹",
        over: "完成绑定",
        binds: "绑定包裹",
        bindorder: "绑定订单",
        statuse: "包裹状态",
        enname: "英文品名",
        lists: "申报列表",
        num: "件数",
        bindnum: "已绑定件数",
        bindover: "已绑定订单",
        yunshu: "运输方式",
        chose: "请选择运输方式",
        orderSta: "订单状态",
        NJ: "新建",
        dianpu: "店铺",
        noBind: "未绑定订单",   
        chaxun: "查询",
        checkmove: "查看更多",
        QS: "签收",
        unpacking: "绑定（拆包）",
        BD: "绑定",
        BD1: "绑定（多包裹，拆包）",
        BD2: "绑定（多包裹，不拆包）",
        BD3: "绑定（一订单一包裹）",
        meidao:"未到库包裹",
        shiF:"是否绑定完成",

    },
    EN: {  //英文翻译
        choose: "Please select",
        packages: "Package binding order",
        orders: "Order binding package",
        over: "Finish binding",
        binds: "Bound package",
        bindorder: "Bind order",
        statuse: "Package status",
        enname: "English product name",
        lists: "Declaration list",
        num: "number",
        bindnum: "Number of bound pieces",
        bindover: "Bound order",
        yunshu: "type of shipping",
        chose: "Please select transportation mode",
        dianpu: "shop",
        orderSta: "Order status",
        NJ: "newly build",
        noBind: "Unbound order",
        chaxun: "query",
        checkmove: "See more",
        QS: "Sign for",
        unpacking: "Binding (unpacking)",
        BD: "bind",
        BD1: "Binding (multiple packages, unpacking)",
        BD2: "Binding (multiple packages without unpacking)",
        BD3: "Binding (one order, one package)",
        meidao:"Package not in warehouse",
        shiF:"Is binding complete",

    }
}
export default info